import React from 'react';
import { Controller } from 'react-hook-form';

import { ResponsiveSelect as GarnishResponsiveSelect } from '../ResponsiveSelect';

import type { ControlledProps, FormProps } from './types';

type ComponentProps = React.ComponentProps<typeof GarnishResponsiveSelect>;
type OmittedProps = ControlledProps | 'onSelect';
type Props = FormProps & Omit<ComponentProps, OmittedProps>;

export const ResponsiveSelect = ({ name, control, rules, ...rest }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <GarnishResponsiveSelect
          value={value}
          onSelect={(selected) => {
            onChange(selected);
            onBlur();
          }}
          {...rest}
        />
      )}
    />
  );
};
